import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './style.module.css';

const InfoBox = (props) => {
  //console.log('DialogBox1', props);
  const {
    openInfoDialog,
    title,
    text,
    setOpenInfoDialog,
    onConfirm,
  } = props.data;
  //console.log('DialogBox2', openDialog);
  // const [source, setSource] = useState('/media/svg/icons/Code/Info-circle.svg');
  const onNothing = () => {
    console.log('onClose');
    setOpenInfoDialog(false);
  };
  let onClickButton = onConfirm === undefined ? onNothing : onConfirm;
  return (
    <Dialog
      open={openInfoDialog}
      onClose={() => setOpenInfoDialog(false)}
      aria-labelledby='info-dialog'
      className={css.box}
    >
      {/* <div className={css.imgBox}>
        <img className={css.img} src={toAbsoluteUrl({ source })}></img>
      </div> */}
      <DialogTitle id='info-dialog' className={css.title}>
        {title}
      </DialogTitle>
      <DialogContent>{text}</DialogContent>
      <DialogActions>
        <Button
          id='infodialogOk'
          variant='contained'
          onClick={() => {
            setOpenInfoDialog(false);
            onClickButton();
          }}
          color='secondary'
        >
          <FormattedMessage id='GENERAL.BUTTON.OK' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default InfoBox;
